import React from 'react';
import { strengths } from '../mock';
import * as LucideIcons from 'lucide-react';

const WhyChooseUs = () => {
  return (
    <section className="py-24 bg-[hsl(var(--bg-light))]">
      <div className="container mx-auto px-6 lg:px-12">
        {/* Section Header */}
        <div className="mb-16 text-center">
          <span className="caption mb-4 block">
            Why Choose Us
          </span>
          <h2 className="heading-2 mb-6">
            Our Strengths
          </h2>
          <p className="body-medium max-w-3xl mx-auto">
            Building long-term relationships through excellence and trust
          </p>
        </div>

        {/* Strengths Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {strengths.map((strength, index) => {
            const Icon = LucideIcons[strength.icon];
            return (
              <div
                key={index}
                className="bg-white p-8 rounded-lg border border-[hsl(var(--border-light))] hover:border-[hsl(var(--primary-blue))] hover:shadow-lg transition-all duration-300 group"
              >
                <div className="w-14 h-14 bg-[hsl(var(--primary-blue)/.1)] rounded-lg flex items-center justify-center mb-5 group-hover:bg-[hsl(var(--primary-blue)/.15)] transition-colors">
                  {Icon && <Icon className="text-[hsl(var(--primary-blue))]" size={28} />}
                </div>
                <h3 className="heading-6 mb-3">
                  {strength.title}
                </h3>
                <p className="body-small leading-relaxed">
                  {strength.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
